import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Box} from 'reactjs-admin-lte'
import {Pagination,Button,ButtonToolbar,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl,Form} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import FontAwesome from 'react-fontawesome'
import StockStore from '../../stores/StockStore'
import ConfirmPopup from '../../component/element/ConfirmPopup'
import PullStock from '../../component/element/PullStock'
import IframeModal from '../../component/element/IframeModal'
import CKAutocomplete from '../../component/element/CKAutocomplete'
import AutopartStore from '../../stores/AutopartStore'
import WorkdocStore from '../../stores/WorkdocStore'
import ReportStore from '../../stores/ReportStore';
// import Moment from 'moment';
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

// const TODAY = Moment().format('L LT').replace(Moment().format('YYYY'), parseInt(Moment().format('YYYY')) + 543);
const DEFAULT_ROW = 10
class StockNewMixPaintDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this.car_info_timestmap = Date.now()
  }

  initState(newState){
    
    let state = {
      activePage:1,
      totalPage:1,
      cur_data:[],
      pullStockShow:false,
      loading:false,
      showHistory:false,
      mpNo:'',      
      showNotice:false,
      shopName:'',
      rowBeep:-1,
      data:this.newEmptyRow(DEFAULT_ROW),
      options:[],
      doc:this.getEmptyDoc(),
      input:{car_registration_no:'',response_by:'',request_by:''},
      car_registration_no_list:[],
      stockApproverList:[],
      customerList:[],
      car_info:'',
      bf_queue_id:undefined
    }

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }


  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.doc!==undefined){
      if(newProps.doc.doc_no!==''){
        //console.log('onRe',newProps.doc)    
        this.setState({doc:newProps.doc,car_info:newProps.doc.brand+'/'+newProps.doc.model})
      }else{
        //console.log('onEmptyDoc')
        this.setState({doc:this.getEmptyDoc(),car_info:'',data:this.newEmptyRow(DEFAULT_ROW)})        
      }
      
    }

    if(newProps.show && newProps.show!==this.props.show){
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
      if(newProps.doc.doc_no!==''){
        this.loadData(newProps.doc.doc_no)
      }
    }
  }

  loadCarRegistrationNo(doc) {
    let that = this
    let car = []
    if(doc.car_registration_no!==undefined && doc.car_registration_no.length>=2 && (Date.now() - that.car_info_timestmap)>2000){
      StockStore.loadCarRegistrationNo(doc.car_registration_no,function(result) {
        result.data.forEach(element => {
          car.push({
            id: element.Value,
            label: element.Name,
            car_info: element.car_info,
            work_no :element.work_no
          })
        });
        that.setState({car_registration_no_list:car})
        that.car_info_timestmap = Date.now()
      })
    }
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.Value,
          label: element.Name,
          emp_id: element.employee_id
        })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.Value,
          label: element.Name
        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  subscribeDocChannel(channel){
         
  }

  renameDoc(newSoNo){
    let {doc} = this.state
    
    this.setState({mpNo:newSoNo,doc:doc})
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {serial_no:'',colorcode:'',end_quantity:'',begin_quantity:'',unit:'',remark:'',productcode:'',itemcode:''}
    })
  }

  getEmptyDoc(){
    return {work_no:'',colorcode:'',doc_no:'',description:'',response_by:'',request_by:''}
  }

  handleSelect(pageSelect) { 
    let {cur_data} = this.state
    if (cur_data.length > 10) {
      let data = []
      let end = (pageSelect * 20) - 1
      let start = end - 19
      for (var i=start;i<=end;i++) {
        if (i<cur_data.length) {
          data.push(cur_data[i])
        }
      }
      this.setState({activePage:pageSelect, data:data})
    }
  }

  loadData(mpNo) {
    

    this.setState({ loading: true, mpNo: mpNo })
    StockStore.loadMixPaintItem(mpNo,  (result)=> {
      let data = result.data
      if (result.data.length < DEFAULT_ROW) {
        data = data.concat(this.newEmptyRow(DEFAULT_ROW - result.data.length))
      }else{
        data = data.concat(this.newEmptyRow(1))
      }
      if(data.length>DEFAULT_ROW){
        this.pcInput = new Array(data.length).fill('')        
      }

      
      
      this.setState({ loading: false,  data: data },()=>{
        if(this.pcInput[result.data.length]!=="")
          ReactDOM.findDOMNode(this.pcInput[result.data.length]).focus();
      })
    })
  }

  onPrintClick(){
    let {soNo} = this.state
    if (process.env.NODE_ENV === "development") {
        window.open('https://demo-fast.bigfix.co/sriracha/pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }else{
        window.open('./pdf/?po=' + soNo + '&file=saleorder_doc', '_blank');
    }
  }

  onCustomerClick(){
    //this.setState({show:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  

  onSaveClick(){
    let {doc,data} = this.state
    this.saveStockMixPaint(doc,data)  
  }

  saveStockMixPaint(doc,data){
    let {messages} = this.props
    let that = this
    this.setState({loading:false})
    let postData = {doc:doc,itemlist:data}
    
    StockStore.saveStockMixPaintItem(postData,function(result){
      if(result.status==='OK'){
        doc.doc_no = result.id
        that.setState({loading:false,doc:doc})
        that._notificationSystem.addNotification({
          title:messages['Notice'],
          message: messages['Save Successfully'],
          level: 'info',
          position:'tc'
        });
      }
    },function(error){
      that.setState({loading:false})
      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Fail Save'],
        level: 'error',
        position:'tc'
      });
    }) 
  }

  onCloseClick(){
    //SubscribeStore.unsubscribe()
    
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  getTotalPage() {
    let {cur_data} = this.state
    let totalPage = cur_data.length / 20
    totalPage = Math.round(totalPage)
    this.setState({totalPage:totalPage})
  }
  
  onDeleteRowClick(index){ 
    let {doc,data,cur_data} = this.state

    cur_data.splice(index,1);
    data.splice(index,1);
    this.setState({data:data, cur_data:cur_data})    
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data} = this.state
    let value = e.target.value
    data[index][key] = value
    if(['end_quantity','begin_quantity'].includes(key)){
      data[index]['used_quantity'] = (data[index]['begin_quantity']*1 - data[index]['end_quantity']*1).toFixed(2)
      
    }

    
    this.setState({doc:doc,data:data})
  }

  onRowAdd(number){
    let {data} = this.state
    
    
    data = data.concat(this.newEmptyRow(number))

    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }


  onSearch(index, query) {
    let that = this
    StockStore.loadSearchProductMixpaint('color', query, function (result) {
      let options = result.data.map((item, index) => {
        return { id: item.itemnum, productCode: item.productcode, itemnum: item.itemnum, categoryName: item.cat_name, detail: item.description, pricePerUnit: item.price_per_unit }
      })
      that.setState({ options: options })
    })
  }


  onProductCodeSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockCodePartItemList(-1,query,function(result){
      //console.log(result)
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
  }

  onTypeaheadInputChange(index,query){
    let {data} = this.state
    data[index]['colorcode'] = query
    this.setState({data:data})
  }

  onTypeaheadChange(index,option){
    let {data} = this.state
    if(option.length===1){
      data[index].colorcode = option[0].detail
      if(option[0].itemnum!==undefined){
        data[index].productcode = option[0].productCode
      }
    }
    this.setState({data:data})
  }

  onTextKeyPress(index,key,target) {
    if(target.charCode===13){
      this.onSaveClick()
    }
  }


  onSearchCarKeyPress(e) {
    if (e.charCode === 13) {
      let {doc} = this.state
      let that = this
      WorkdocStore.loadWorkdocCarInfo(e.target.value,function(result){
        let item = result.data     
        if(item.work_no!==''){   
          doc.work_no =  item.work_no         
          doc.car_registration_no = item.car_registration_no              
          that.setState({doc:doc,car_info:item.car_info})
          that._description.focus()
        }else{
          doc.work_no = ''
          doc.car_registration_no = '';
          that.setState({doc:doc,car_info:that.props.messages['Car Registration Not Found']})
        }
      })
    }
  }

  onSearchKeyPress(index,key,target) {
    if(target.charCode===13){
      let {data} = this.state
      let {messages} = this.props
      // console.log("code enter",data[index])    
      let that = this,foundIndex = -1
      let productcode = data[index][key];
      //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      //Finding duplicate
      
      data.map((item,iindex)=>{
        if(item.productcode===productcode && iindex!==index){
          foundIndex = iindex
        }
      })
      if(foundIndex>=0){
        
        data[index].productcode = ''
        
      }else{
        this.setState({loading:true})
        
        AutopartStore.loadStockProductCode('color',productcode,function(result){
          //console.log(result)
          //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
          if(result.data.length>0){
            let item = result.data[0]                           
            data[index].productcode = item.productcode
            data[index].colorcode = item.description
            

            if(index===data.length-1){
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index+1] = ''
            }
            that.setState({loading:false,data:data})
            ReactDOM.findDOMNode(that.pcInput[index+1]).focus();
            
          }else{
            data[index].productcode = ''
            that.setState({loading:false,data:data})
            that._notificationSystem.addNotification({
              title:messages['Notice'],
              message: messages['Serial No Not Found']+' '+productcode+' '+messages['In Warehouse'],
              level: 'warning',
              position:'tc'
            });
          }
        })      
      }
      this.setState({data:data,rowBeep:foundIndex})
        setTimeout(function(){ 
          that.setState({rowBeep:-1})
        }, 1500);
    }
    
  }


  onMenuItemSelect(index){
    if('clearlist'===index){
      this.setState({clearShow:true})
    }else if("adjuststock"===index){
      this.setState({stockShow:true})      
    }else if("print"===index){
      let url = ''
      if (process.env.NODE_ENV === "development") {
        url  = './?startPage=PrintReportStockCheck&type='+this.props.stockType
      } else{
        url = './pdf/v2/?startPage=PrintReportStockCheck&type='+this.props.stockType
      }
      this.refs.iframe.loadUrl(url)
    }else if ("pullstock"===index) {
      this.setState({pullStockShow:true})
    }
  }

  onConfirmStockClear(){
    this.setState({clearShow:false,data:this.newEmptyRow(DEFAULT_ROW)})
    this.saveStockCheck([])
  }

  onConfirmStockSave(){
    let {data} = this.state 
    let {messages} = this.props
    let that = this
    StockStore.requestStockAdjust(this.props.stockType,data,function(result){
      data = data.map((item,index)=>{
        item.stock_quantity = item.quantity
        return item
      })
      that.setState({stockShow:false,data:data})
      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Adjust Quantity Of Warehouse'],
        level: 'info',
        position:'tc'
      });
    },function(){
      that.setState({stockShow:false})
    })
  }

  onTextBlur(index,e) {
    let {data} = this.state
    let that = this
    that.setState({loading:false})
    StockStore.loadMixpaintItemcode(data[index].productcode,e.target.value,function(result) {
      if (result.data.length>0) {
        data[index].last_quantity = result.data[0].end_quantity
      } else {
        data[index].last_quantity = ''
      }
      that.setState({data:data,loading:false})
    })
  }

  onDataChange(cat_id) {
    let that = this
    let {messages} = this.props
    ReportStore.loadStockList(this.props.stockType, "", cat_id, "", "", "", function(result) {
      // that.setState({data:result.data})
      let data = result.data.map((item,index)=>{
        item.stock_quantity = item.quantity
        item.quantity = ''
        item.detail = item.description
        return item
      })

      if(data.length <10) {
        data = data.concat(that.newEmptyRow(10-data.length))
        that.setState({data:data, totalPage:1})
        that.saveStockCheck(data)
      } else {
        let all_data = data
        let totalPage = all_data.length / 20
        totalPage = Math.round(totalPage)
        if (totalPage > 1) {
          data = []
          for (var i=0;i<20;i++) {
            data.push(all_data[i])
          }
        } else {
          totalPage = 1
        }
        that.setState({data:data, totalPage:totalPage, cur_data:all_data})
        that.saveStockCheck(all_data)
      }

      that._notificationSystem.addNotification({
        title:messages['Notice'],
        message: messages['Pull Data Successfully'],
        level: 'info',
        position:'tc'
      });
      //console.log('result',result)
    })
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let {messages} = this.props
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' '+messages['Have Number']+' '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} ({messages['Category']}{option.categoryName}) - {option.pricePerUnit} {messages['Bath']} {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }


  renderRemark(){
    let {description} = this.state.doc
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          controlId="formBasicText"
          validationState={this.getValidationState()}
        >
          <ControlLabel>{this.props.messages['Remark']}</ControlLabel>
          <InputGroup>            
            <FormControl value={description} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'description')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  getRowClassName(item,index){
    
    return ''
  }

  onHideClick(e) {
    this.setState({pullStockShow:e})
  }

  onHeadInputChagne(field,e){
    let {doc} = this.state
    doc[field] = e.target.value

    this.setState({doc:doc})
  }

  renderRowData(){
    let {data,options} = this.state
    let {messages} = this.props
    return data.map((item,index)=>(
      <tr key={index} className={this.getRowClassName(item,index)}>
        <td className='text-center'>{index+1}</td>
        <td className='data-column'>
          <FormControl className='text-left' 
          ref={(input) => { this.pcInput[index] = input; }} 
          value={item.productcode} 
          onChange={this.onFormChange.bind(this,index,'productcode')}
          onKeyPress={this.onSearchKeyPress.bind(this,index,'productcode')}
          />          
        </td>        
        <td className='data-column text-center'>
          <AsyncTypeahead
            allowNew={true}
            multiple={false}
            newSelectionPrefix={messages['Add New Item']+' : '}
            promptText={messages['Keypress For Searching']}
            searchText={messages['Searching']}
            selected={[{ detail: item.colorcode }]}
            options={options}
            labelKey="detail"
            onSearch={this.onSearch.bind(this, index)}
            onChange={this.onTypeaheadChange.bind(this, index)}
            onInputChange={this.onTypeaheadInputChange.bind(this,index)}
            placeholder=""
            renderMenuItemChildren={this._renderMenuItemChildren}
          />
        </td>
        <td  className='data-column text-center'><FormControl className='text-center' 
        value={item.itemcode} 
        onChange={this.onFormChange.bind(this,index,'itemcode')}        
        onBlur={this.onTextBlur.bind(this,index)}
        /></td>                      
        <td  className='data-column text-center'><FormControl className='text-center' 
        value={item.begin_quantity} 
        onChange={this.onFormChange.bind(this,index,'begin_quantity')}        
        /></td>
        <td  className='data-column text-center'><FormControl className='text-center' 
        value={item.end_quantity} 
        onChange={this.onFormChange.bind(this,index,'end_quantity')}        
        /></td>
        <td className='text-center'>{item.used_quantity}</td>
        <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='close'/></Button></td>
      </tr>
    ))

  }


  renderTable(){
    let {messages} = this.props
    return (
      <div className='display-overflow'>
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['Number']}</th>
            <th className='text-center' style={{width:'200px'}}>{messages['Barcode']}</th>
            <th className='text-center' style={{width:'150px'}}>{messages['Primary Color Code']} KT+KB+WB</th>
            <th className='text-center' style={{width:'150px'}}>{messages['Canned No']}</th>            
            <th className='text-center' style={{width:'150px'}}>{messages['Weight Before']}</th>
            <th className='text-center' style={{width:'150px'}}>{messages['Weight After']}</th>     
            <th className='text-center' style={{width:'150px'}}>{messages['Use']}</th>            
            <th className='text-center' style={{width:'30px'}}>{messages['Delete']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr >            
            <th colSpan={4} className='text-right'>{messages['Total Of Item']}</th>
            <th colSpan={5}></th>
        </tr>
        </tfoot>
      </table>
      </div>
    )
  }

  renderNewItemButton(){
    let {messages} = this.props
    return (
      <div style={{display:'inline-flex'}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
        </ButtonToolbar>       
      </div>
    )
  }

  
  renderStockStatus(){
    let {doc} = this.state
    let {messages} = this.props
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>{messages['Stock Cut']}</span>)
    }else{
      return (<span/>)
    }
  }

  onTextChange(key,e) {
    let {doc} = this.state

    if (doc==="")
      doc = this.getEmptyDoc()

    doc[key] = e.target.value
    this.setState({doc:doc})
    if (key==='car_registration_no') {
      this.loadCarRegistrationNo(doc)
      if(e.target.value==='')
        this.setState({car_info:''})
    }
  }

  onTextSelect(key, e) { 
    let {doc,car_registration_no_list} = this.state

    if (doc==="")
      doc = this.getEmptyDoc()
    
    if (key==='car_registration_no') {
      let value = ''
      let car_info = ''
      
      car_registration_no_list.forEach(function(item,index) {
        if(e===item.label) {
          value = item.id
          car_info = item.car_info
          doc.work_no =  item.work_no
        }  
      })

      doc[key] = value      
      car_info = car_info
      this.setState({doc:doc,car_info:car_info})
      this._description.focus()
    } else {
      doc[key] =  e
      this.setState({doc:doc})

      if (key==='mixed_by')
        this.refs._request_by.onFocus()
      else if (key==='request_by')
        this.refs._response_by.onFocus()
      else if (key==='response_by')
        this.refs._car_registration_no.onFocus()
    }
  }

  onEmpTextKeyPress(key,e) {
    if (e.charCode === 13) {
      e.preventDefault()

      let {customerList,doc} = this.state
      let checkSearch = false
      let value = ''
      let {messages} = this.props
      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.id
        }
      })

      if (checkSearch) {
        if (key==='request_by') {
          doc[key] = value
          this.refs._response_by.onFocus()
        } else if (key==='response_by') {
          doc[key] = value
          this.refs._car_registration_no.onFocus()
        } else if (key==='mixed_by') {
          doc[key] = value
          this.refs._request_by.onFocus()
        }
      } else { 
        doc[key] = ''

        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }  
      this.setState({doc:doc})
    }  
  }

  onSetWorkNo(item) {
    let {doc,data} = this.state
    doc.work_no = item.work_no
    doc.car_registration_no = item.car_registration_no
    doc.request_by = item.request_by
    doc.mixed_by = item.mixed_by
    doc.colorcode = item.colorcode
    doc.response_by = item.response_by
    doc = Object.assign({bf_queue_id:item.bf_queue_id,mixpaint_no:item.mixpaint_no,request_mix_date:item.request_mix_date,start_mix_date:item.start_mix_date,end_mix_date:item.end_mix_date}, doc)
    this.setState({doc:doc,car_info:item.car_info,bf_queue_id:item.bf_queue_id})
    if (item.mixpaint_no=='0')
      this.saveStockMixPaint(doc,data)
    else
      this.loadData(item.mixpaint_no)  
  }

  onJobDoneClick() {
    let {doc,data} = this.state
    let {messages} = this.props
    this.saveStockMixPaint(doc,data)
    setTimeout(()=>{
      let postData = {bf_queue_id:this.state.bf_queue_id}
      StockStore.saveMixpaintQueue('finished',postData,(result)=>{
        if (result.status==='OK') {
          this._notificationSystem.addNotification({
            title:messages['Notice'],
            message: messages['Finish Done'],
            level: 'info',
            position:'tc'
          });
        }
        setTimeout(()=>{
          this.onCloseClick()
        },1000)
      })
    },1000)
  }

  renderHeadTable() {
    let {doc,car_registration_no_list,customerList} = this.state
    let {messages} = this.props
    return(
            <Form>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Document Number']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder={'<'+messages['Auto Generated Number']+'>'} value={doc.mixpaint_no} className="input-dark" />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Date Request Color Mixed']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={doc.request_mix_date}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Date Start']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" value={doc.start_mix_date} className="input-dark" readOnly={true}  />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Date Done']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" value={doc.end_mix_date}  className="input-dark" readOnly={true} />
                  </FormGroup>
                </Col>
              </Row>
              
              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Technician']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.mixed_by}
                          onChange={this.onTextChange.bind(this, 'mixed_by')}
                          onSelect={this.onTextSelect.bind(this, 'mixed_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'mixed_by')}
                        />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Color Mixed Code']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl type="text" placeholder="" value={doc.colorcode} onChange={this.onHeadInputChagne.bind(this,'colorcode')} />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Requester']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.request_by}
                          onChange={this.onTextChange.bind(this, 'request_by')}
                          onSelect={this.onTextSelect.bind(this, 'request_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'request_by')}
                          ref='_request_by'
                        />
                  </FormGroup>
                </Col>  
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Queue Maker']}<span className="color-red">*</span></ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <CKAutocomplete
                          top={'-35px'}
                          items={customerList}
                          value={doc.response_by}
                          onChange={this.onTextChange.bind(this, 'response_by')}
                          onSelect={this.onTextSelect.bind(this, 'response_by')}
                          onKeyPress={this.onEmpTextKeyPress.bind(this, 'response_by')}
                          ref='_response_by'
                        />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Car Registration']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                        <CKAutocomplete
                          top={'-35px'}
                          choiceStyle={{width:'350px'}}
                          items={car_registration_no_list}
                          value={doc.car_registration_no}
                          onKeyPress={this.onSearchCarKeyPress.bind(this)}
                          onChange={this.onTextChange.bind(this, 'car_registration_no')}
                          onSelect={this.onTextSelect.bind(this, 'car_registration_no')}
                          ref='_car_registration_no'
                        />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{this.state.car_info}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup>
                    <ControlLabel>{messages['Description']}</ControlLabel>
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <FormControl inputRef={(input) => { this._description = input }} type="text" placeholder="" value={doc.description} onChange={this.onHeadInputChagne.bind(this,'description')} />
                  </FormGroup>
                </Col>
              </Row>
            </Form>
    )
  }

  renderPaging(){
    let {messages} = this.props
    return (
      <div>
          <div className="text-right">
            <Pagination
              prev={messages['Previous']}
              next={messages['Next']}
              first={false}
              last={false}
              ellipsis
              boundaryLinks
              items={this.state.totalPage}
              maxButtons={5}
              activePage={this.state.activePage}
              onSelect={this.handleSelect.bind(this)}
            />
          </div>
        </div>
    )
  }

  render(){
    let {loading,stockShow,clearShow,pullStockShow,bf_queue_id} = this.state
    let {messages} = this.props
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    let {show}  = this.props
    return (
      <div style={{display:show?'block':'none'}}>
        <Box loading={loading}>
          <Box.Header  className='text-center'>
            <Box.Title>
              {messages['Picking Primary Color Mixed List']}
            </Box.Title>
            <Box.Tools className='pull-right'>
              <ButtonToolbar>                                            
                  <Button                             
                  bsStyle={'link'} className='bg-maroon'
                  onClick={this.onPrintClick.bind(this)}
                >
                  <FontAwesome name='print'/>&nbsp;{messages['Print Document']}
                </Button>
              </ButtonToolbar>                     
            </Box.Tools> 
          </Box.Header>
          <Box.Body>
            {this.renderHeadTable()}
            {this.renderTable()}
            {this.renderNewItemButton()} 
            <IframeModal ref='iframe' title={messages['Print Document']} />
            <NotificationSystem ref="notificationSystem" style={style}/>
            <ConfirmPopup show={stockShow} 
              title={messages['Confirm Title']} 
              message={messages['Confirm Adjust']}
              confirmTitle={messages['Confirm']} 
              onConfirm={this.onConfirmStockSave.bind(this)}
              onHide={()=>{this.setState({stockShow:false})}}        
              /> 
            <ConfirmPopup show={clearShow} 
              title={messages['Confirm Title']} 
              message={messages['Confirm New']}
              confirmTitle={messages['Confirm']} 
              onConfirm={this.onConfirmStockClear.bind(this)}
              onHide={()=>{this.setState({clearShow:false})}}        
              /> 
            <PullStock
              show={pullStockShow}
              onHide={this.onHideClick.bind(this)}
              stockType={this.props.stockType}
              onDataChange={this.onDataChange.bind(this)}
            />      
          </Box.Body>    
          <Box.Footer>
            <ButtonToolbar className='pull-right'>
              {bf_queue_id==undefined?'':<Button bsStyle='success' onClick={this.onJobDoneClick.bind(this)}><FontAwesome name='check' />&nbsp;{messages['Done']}</Button>}
              <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
              <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
            </ButtonToolbar>
          </Box.Footer>    
        </Box>        
      </div>
    )
  }
}

StockNewMixPaintDoc.defaultProps = {
  show:false,
  showHead: true,
  title: 'รายการเบิกแม่สีผสม'
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockNewMixPaintDoc}),null,null,{withRef:true},
)(StockNewMixPaintDoc);



// WEBPACK FOOTER //
// ./src/view/stock/StockNewMixPaintDoc.js